/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const SubProductListPage = lazyLoad(
  () => import('./index'),
  module => module.SubProductListPage
);
